import { render, staticRenderFns } from "./SessionCompatibilityBlockSmall.vue?vue&type=template&id=80014e10&scoped=true"
import script from "./SessionCompatibilityBlockSmall.vue?vue&type=script&lang=js"
export * from "./SessionCompatibilityBlockSmall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80014e10",
  null
  
)

export default component.exports